<script lang="ts">
    export let Text: string;
    export let Icon: string;
    export let Type: string = "primary";
    export let MarginRight: boolean = true;
</script>

<button
    type="button"
    class="btn"
    class:btn-primary={Type == "primary"}
    class:marg-rght={MarginRight}
    on:click
>
    <i class="fa {Icon}" /> {Text}
</button>

<style>
    .marg-rght{
        margin-right: 1rem;
    }
</style>